import {Injectable} from '@angular/core';
import {ApiService} from 'app/shared/modules/api/services/api.service';
import {uaSettings_analytics_uaSettings, uaSettings as uaSettingsI} from 'app/features/analytics/service/gql/uaSettings';
import {gql} from '@apollo/client/core';
import {AuthService} from 'app/core/services/auth.service';
import {Observable, of} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

export type uaSettings = uaSettings_analytics_uaSettings;

const uaSettingsQuery = gql`
    query uaSettings($userId: ID, $app: ID) {
        analytics {
            uaSettings(appId: $app, userId: $userId) {
                defaultDayN
                isAppsflyerConnected
                isHsClient
            }
        }
    }
`;

@Injectable({
    providedIn: 'root',
})
export class UaSettingsService {
    constructor(
        private api: ApiService,
        public auth: AuthService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        if (!this.auth.getCurrentUserLastValue()) {
            return;
        }
        return this.init();
    }

    public uaSettings: uaSettings_analytics_uaSettings;
    public settings$: Observable<uaSettings>;

    init(): Observable<uaSettings> {
        this.settings$ = this.getUaSettings().pipe(tap(v => (this.uaSettings = v)));
        return this.settings$;
    }

    fetchUaSettings() {
        return this.api
            .query<uaSettingsI>({
                query: uaSettingsQuery,
                variables: {
                    userId: this.auth.currentUserId,
                },
            })
            .pipe(map(r => r.analytics.uaSettings));
    }

    get canViewFunnels() {
        return this.auth.getCurrentUserLastValue()?.permissions.canViewFunnels;
    }

    isAdmin() {
        return this.auth.getCurrentUserLastValue()?.permissions.canViewInternalDashboard;
    }

    getUaSettings(): Observable<uaSettings_analytics_uaSettings> {
        if (!this.auth.isLoggedIn()) {
            return of({
                __typename: 'UaSettings',
                defaultDayN: 730,
                isAppsflyerConnected: false,
                isHsClient: false,
            });
        }

        if (this.isAdmin()) {
            return of({
                __typename: 'UaSettings',
                defaultDayN: 730,
                isAppsflyerConnected: true,
                isHsClient: false,
            });
        }

        return this.fetchUaSettings();
    }
}
